import { ICreateUserService } from "@modules/user/models/ICreateUserService";
import { ICreateUserDTO } from "@modules/user/dtos/ICreateUserDTO";
import { safeExecute } from "@utils/safeExecute";

export function createUser(service: ICreateUserService, data: ICreateUserDTO) {
  return safeExecute(
    () => service.execute(data),
    "Ocorreu um erro ao cadastrar usuário"
  );
}
